import React, { useState } from "react";
import axios from "axios";

import "./pendingAssetDeleteButton.css";

const PendingAssetDeleteButton = ({ asset, isTransfer, onDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    const assetLabel = asset.assetName || asset.trackingId || "this asset";
    if (!window.confirm(`Delete pending asset "${assetLabel}"? This cannot be undone.`)) {
      return;
    }

    setIsDeleting(true);
    try {
      const url = isTransfer
        ? `/api/transfer/pending/${asset._id}`
        : `/api/PendingAssetRegisterDetails/pending/${asset._id}`;
      await axios.delete(url);
      onDeleted(asset._id);
    } catch (error) {
      alert(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Unable to delete the pending asset."
      );
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <button
      type="button"
      className="deletestsatus"
      onClick={handleDelete}
      disabled={isDeleting}
    >
      {isDeleting ? "Deleting..." : "Delete"}
    </button>
  );
};

export default PendingAssetDeleteButton;
